/** @format */

import ViewBox from 'frontier/components/die_template/view_box';
import React from 'react';
import {
    bleedlineStyle,
    dielineStyle,
    safeZoneStyle
} from 'frontier/components/die_template/line_styles';

export default function EllipseSvg(props) {
    const bleed = 0.125;
    return (
        <ViewBox width={props.width + bleed} length={props.length + bleed}>
            <ellipse
                id="Bleedline"
                cx={(props.width + bleed) / 2}
                cy={(props.length + bleed) / 2}
                rx={(props.width + bleed) / 2}
                ry={(props.length + bleed) / 2}
                style={bleedlineStyle}
            />
            <ellipse
                id="Dieline"
                cx={(props.width + bleed) / 2}
                cy={(props.length + bleed) / 2}
                rx={props.width / 2}
                ry={props.length / 2}
                style={dielineStyle}
            />
            <ellipse
                id="Safezone"
                cx={(props.width + bleed) / 2}
                cy={(props.length + bleed) / 2}
                rx={(props.width - bleed) / 2}
                ry={(props.length - bleed) / 2}
                style={safeZoneStyle}
            />
        </ViewBox>
    );
}
